import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52e66523"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page-container" }
const _hoisted_2 = ["src"]

import { ref, watch, provide, Ref } from 'vue'
import PageContainer from '@/mobile/src/components/appV4/PageContainer.vue'
import IconLogo from '@/assets/img/logo/asknicely_logo_white.svg'
import router from '@/mobile/src/router'
import { getMergedMeta } from '@/utils/routing'
import ToastOverlay from '@/mobile/src/components/appV4/ToastOverlay.vue'
import { LoginMainPkey, Credentials } from '@/mobile/src/types/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMain',
  setup(__props) {

const defaultCreds: Credentials = {
    email: '',
    password: '',
}

const credentials: Ref<Credentials> = ref(defaultCreds)
const routerRef = ref(router)
const mergedMeta = ref({})
watch(
    () => routerRef.value.currentRoute,
    (currentRoute) => {
        mergedMeta.value = getMergedMeta(currentRoute)
    },
    { immediate: true }
)
const persistCredentials = (creds: Credentials) => {
    credentials.value = creds
}
const resetCredentials = () => {
    credentials.value = defaultCreds
}
provide(LoginMainPkey, { credentials, persistCredentials, resetCredentials })

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageContainer, { "no-nav-pad": "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["login-page", { center: mergedMeta.value.center }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["logo", { 'no-logo': !mergedMeta.value.hasLogo }])
          }, [
            _createElementVNode("img", {
              src: _unref(IconLogo),
              alt: "AskNicely"
            }, null, 8, _hoisted_2)
          ], 2),
          _createVNode(_component_RouterView)
        ], 2)
      ], undefined, true),
      _: 1
    }),
    _createVNode(ToastOverlay)
  ]))
}
}

})